export const TOAST_CONSTANTS = {
  SWIPE_THRESHOLD: -50,
  AUTO_DISMISS_DELAY: 5000,
  ANIMATION_DURATION: {
    ENTRY: 400,
    EXIT: 300,
    BOUNCE: 200,
  },
  OPACITY: {
    LINK_PRESS: 0.7,
    NO_LINK: 1,
  },
  POSITION: {
    HIDDEN: -100,
    VISIBLE: 0,
  },
} as const
